import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  reportsDataService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';

import controller from './bulk-delete-report-instance.controller';
import directive from './bulk-delete-report-instance.directive';

export default angular.module('app.components.reports.myReports.reportType.bulkDeleteReportInstance', [
    alerts,
    actionIcon,
    confirmDialog,
    loaderService,
    ssDialogService,
    reportsDataService,
  ])
  .directive('bulkDeleteReportInstance', directive)
  .controller('BulkDeleteReportInstanceController', controller)
  .name;

console.log('aapp.components.reports.myReports.reportType.bulkDeleteReportInstance created');
